<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      SuperAdmin Area
    </h1>
    <template v-if="legacyFeatShow">
      <p class="mb-8 leading-normal">
        Restricted only to SuperAdmin role
      </p>
      <button
        :disabled="isLoading"
        @click="importMahasiswa"
        class="flex items-center btn-indigo"
        title="Import data mahasiswa from AWS S3">
        <div v-if="isLoading" class="btn-spinner mr-2" />
        Import Mahasiswa
      </button>
      <br>
      <div>
        <file-input
          v-model="check_files"
          class="pr-6 pb-4 w-full lg:w-1/2"
          type="file"
          label="File xlsx list mahasiswa untuk di cek:" />

        <button
          class="btn-indigo"
          type="button"
          @click.prevent="uploadBerkasCheck">
          Upload
        </button>
      </div>
      <div class="row">
        <table class="table">
          <tr>
            <th>Nama di file</th>
            <th>Rekening di file</th>
            <th>Bank di file</th>
            <th>Status</th>
            <th>Nama di sistem</th>
            <th>Universitas</th>
            <th>Status Verif</th>
          </tr>
          <tr v-for="(row, index) in checklistMahasiswa" :key="index">
            <td>
              {{ row.name_of }}
            </td>
            <td>
              {{ row.no_rek_of }}
            </td>
            <td>
              {{ row.bank_of }}
            </td>
            <td>
              {{ row.status }}
            </td>
            <td>
              {{ row.name }}
            </td>
            <td>
              {{ row.universitas }}
            </td>
            <td>
              {{ row.verif }}
            </td>
          </tr>
        </table>
      </div>
    </template>
    <form @submit.prevent="submit">
      <div class="row mt-4">
        <h2>Upload Berkas Akhir Studi Mahasiswa</h2>
      </div>
      <div class="row mt-4">
        <file-input
          v-model="form.eos_payments_file"
          class="pr-6 pb-4 w-full lg:w-1/2"
          type="file"
          label="File .csv berkas akhir studi untuk di import:" />
      </div>
      <progress
        v-if="form.progress"
        :value="form.progress.percentage"
        max="100">
        {{ form.progress.percentage }}%
      </progress>
      <button
        :disabled="form.progress"
        class="flex items-center btn-indigo"
        title="Import data mahasiswa from AWS S3">
        <div v-if="form.progress" class="btn-spinner mr-2" />
        Upload dan Proses Data akhir studi
      </button>
    </form>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import { router, useForm } from '@inertiajs/vue2'

export default {
    metaInfo: { title: 'Config' },
    layout: Layout,

    data () {
        return {
            isLoading: false,
            check_files: null,
            checklistMahasiswa: [],
            form: useForm({
                eos_payments_file: null,
            }),
        }
    },
    computed: {
        legacyFeatShow: () => false,
    },
    components: {
        FileInput,
    },
    methods: {
        submit () {
            this.form.post('/import/eosfile', {
                onSuccess: () => this.form.reset('eos_payments_file'),
            })
        },
        importMahasiswa () {
            router.post(this.route('import.mahasiswa'), null, {
                onStart: () => (this.isLoading = true),
                onFinish: () => (this.isLoading = false),
            })
        },
        uploadBerkasCheck () {
            let formData = new FormData()
            formData.append('check_files', this.check_files)
            // axios
            //     .post(this.route('import.mahasiswa.checkfiles'), formData, {
            //         headers: {
            //             'Content-Type': 'multipart/form-data',
            //         },
            //     })
            //     .then((response) => {
            //         this.checklistMahasiswa = response.data
            //     })
        },
    },
}
</script>
